module.exports = __webpack_public_path__ + "static/media/pagination-start.e1e27010.svg";